export default {
  id: '',
  name: '',
  address: '',
  contactNumber: '',
  storeInCharge: '',
  updatedBy: '',
  isDeleted: '',

};
